import { render, staticRenderFns } from "./EmptyAlertAllowBehaviorEditor.vue?vue&type=template&id=5c727e7e&scoped=true&"
import script from "./EmptyAlertAllowBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./EmptyAlertAllowBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyAlertAllowBehaviorEditor.vue?vue&type=style&index=0&id=5c727e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c727e7e",
  null
  
)

export default component.exports